/**
 * TS-Promise - fast, robust, type-safe promises
 *
 * Copyright (C) 2015 Martin Poelstra
 * License: MIT
 */
"use strict";
var Promise_1 = require("./Promise");
exports.default = Promise_1.default;
exports.Promise = Promise_1.Promise;
exports.UnhandledRejectionError = Promise_1.UnhandledRejectionError;
var polyfill_1 = require("./polyfill");
exports.polyfill = polyfill_1.default;
// Temporary, should be moved to its own package some day
var BaseError_1 = require("./BaseError");
exports.BaseError = BaseError_1.default;
//# sourceMappingURL=index.js.map